<template>
  <section class="wrapper__tabs">
      <div class="bg">
          <div class="tabs__container">
              <div class="tabs-header">
                  <button
                  v-for="tab in visibleTabs"
                  :key="tab.id"
                  :class="['tab-button', { active: activeTab === tab.id }]"
                  @click="activeTab = tab.id"
                  >
                  {{ tab.title }}
                  </button>
              </div>
          </div>
      </div>
      <div class="tabs__container">
          <div class="tabs-content">
              <div class="description" v-if="activeTab === 'description'">
                  <div class="label">Description</div>
                  <div class="text">{{ machine.description }}</div>
              </div>
              <Specifications v-if="activeTab === 'components'" :array="machine.components"></Specifications>
              <Delivery v-if="activeTab === 'delivery'"></Delivery>
          </div>
      </div>
  </section>
</template>

<script>
import Specifications from '../Product/Tabs/Specifications.vue';
import Delivery from '../Product/Tabs/Delivery.vue';
export default {
  components: {
      Specifications,
      Delivery,
  },
  props: {
    machine: { type: Object, required: true },
  },
  data() {
    return {
      activeTab: 'description',
    };
  },
  computed: {
    visibleTabs() {
      return [
        { id: 'description', title: 'Description', show: !!this.machine.description },
        { id: 'components', title: 'Components', show: this.machine.components.length > 0 },
        { id: 'delivery', title: 'Delivery', show: true },
      ].filter(tab => tab.show);
    },
  },
  created() {
    this.activeTab = this.visibleTabs[0].id;
  },
};
</script>

<style scoped>
.wrapper__tabs{
  padding-bottom: 112px;
}
.bg{
  background: rgba(222, 230, 234, 0.5);
}
.tabs-header {
  display: flex;
}
.tab-button {
  color: rgb(5, 5, 5);
  font-size: 13px;
  font-weight: 500;
  line-height: 140%;
  height: 64px;
  padding: 0 24px;
  text-align: center;
  border: none;
  background-color: #f1f1f1;
  cursor: pointer;
  transition: background-color 0.3s;
}
.tab-button.active {
  background-color: rgb(255, 255, 255);
}
.tab-button:hover:not(.active) {
  background-color: #ddd;
}
.description{
  padding-top: 88px;
  max-width: 900px;
}
.description .label{
  color: rgb(85, 98, 114);
  font-size: 13px;
  font-weight: 500;
  line-height: 140%;
  padding-bottom: 26px;
}
.description .text{
  color: rgb(29, 29, 52);
  font-size: 18px;
  font-weight: 400;
  line-height: 160%;
  white-space: pre-line;
}
@media (max-width: 1024px) {
  .wrapper__tabs{
    padding-bottom: unset;
  }
}
@media (max-width: 768px) {
  .tab-button{
      padding: 0 12px;
  }
  .tabs-header {
    flex-direction: column;
  }
  .tabs__container{
    padding: unset;
  }
  .tabs-content{
    padding: 0 20px;
  }
  .description{
    padding-top: 40px;
  }
  .description .text{
    font-size: 16px;
  }
}
</style>
